/**
 * function to check currency in brazilian market
 * should always be BRL for /pt
 */
$(document).ready(function(){
    if(Shopify.locale === 'pt-BR'){
        const currencyCookie = getCookie('cart_currency');
        if(currencyCookie !== 'BRL'){
            // get currency form and submit
            const currencyForm = $('#currency_form');
            const currencyInput = currencyForm?.find('input[name="currency"]');
            currencyInput.val('BRL');
            currencyForm.submit();
        }
    }
    function waitForBeamerConfig() {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (window.beamer_config) {
                        clearInterval(interval);
                        resolve(window.beamer_config);
                    }
                }, 100);
            });
        }
        waitForBeamerConfig().then((config) => {
            console.log("Beamer config loaded:", config);
            config.language = Shopify.locale === 'pt-BR' ? 'pt' : Shopify.locale;
        });
        function waitForIntercomSettings() {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (window.intercomSettings) {
                        clearInterval(interval);
                        resolve(window.intercomSettings);
                    }
                }, 100);
            });
        }
        waitForIntercomSettings().then((settings) => {
            console.log("Intercom settings loaded:", settings);
            settings.language_override = Shopify.locale === 'pt-BR' ? 'pt' : Shopify.locale;
        });
});
(function () {
    var params = new URLSearchParams(window.location.search);
    var isCheckoutLinkFlow = localStorage.getItem('isCheckoutLinkFlow');
    if(!isCheckoutLinkFlow)localStorage.setItem('currentRoute',window.location.href.split(/[?#]/)[0]);
    if(params.has('error')){
        let switch_company_error=localStorage.getItem('switchCompanyError')
        localStorage.setItem('switchCompanySuccess',false)
        if(switch_company_error=='true'){
            $('#retry_href').attr('href','/pages/company-list')
            $('#switch-company-error').css('display','flex')
            localStorage.removeItem('currentCompany')
        }else{
            $('#alert-pop-up').fadeIn();
            $('#alert-pop-up p').text(params.get('error'));
        }
    }else{
        localStorage.setItem('switchCompanyError',false)
     }
  
    $(document).on('click','#nav-icon4',function(){
		$(this).toggleClass('open');
        $('.l-header-menu-block').toggleClass('open').css('height', window.innerHeight);
        if(!$(this).hasClass('open')){
            $('.l-header-menu-block').removeClass('open');
        }
	});
    $('body').click(function(e) {
        if (!$(e.target).closest('.l-header-menu').length){
            $(".l-header-menu-block").removeClass('open');
            $('body').removeClass('overlay-color');
        }
        if (!$(e.target).closest('#nav-icon4').length){
            if (!$(e.target).closest('.l-header-menu').length){
            $(".hideShow").removeClass('open');
            }
        }
        if (e.target?.getAttribute('href') === "#chatwithus" || e.target?.parentElement?.getAttribute('href') === "#chatwithus") {
            Intercom('show');
        }
    })

    $(document).on('click','#nav-icon4',function(){
        if($(this).parent('.l-header-menu-block').hasClass('open')){
            $('body').removeClass('overlay-color');
        }else{
            $('body').addClass('overlay-color');
        }
    })

    $(document).on('click','.inner-menu-burger-menu',function(){
        $('#nav-icon4.hideShow:not(.inner-menu-burger-menu)').removeClass('open');
        $('body').removeClass('overlay-color');
    }) 

    $(document).on('click','.l-header-language-wrapper .l-dropdown-selected',function(){
        $('.l-header-language-wrapper ul li').slideToggle();
        $('.l-header-language-wrapper .l-dropdown-selected ').toggleClass('open');
    });

    $(document).on('keypress','.l-header-language-wrapper .l-dropdown-selected',function(e){
        if(e.keyCode == 13){ 
            $('.l-header-language-wrapper ul li').slideToggle();
            $('.l-header-language-wrapper .l-dropdown-selected ').toggleClass('open');
        }
    });

    $(document).on('click','.click-li',function(){
        if($(window).width() < 1025){
            $('.show-hide-li').slideToggle();
        }
    });

    $(window).resize(function(){
        if($(this).width() > 1024){
            $('.show-hide-li').show();
        }
    })

    $(document).on('click', function (e) {
        if ($(e.target).closest(".l-header-language-wrapper").length === 0) {
            $(".l-header-language-wrapper .select-list li").slideUp();
            $('.l-header-language-wrapper .l-dropdown-selected ').removeClass('open');
        }
        if ($(e.target).closest(".l-header-profile-block").length === 0) {
            $('.l-header-profile-user').removeClass('open');
        }
    });

    $(document).on('click','#l-header-profile', function(){
        $('.l-header-profile-user').toggleClass('open');
    });
    $(window).on('popstate', function(event) {
        if($('#l-header-profile').hasClass('open')){
            $('#l-header-profile').toggleClass('open');
        }
    });
    $(document).on('click','.cart-info-close',function(e){
        let current_em = $(e.target);
        let attribute= $('#switch').attr('data-close')
       if(attribute=='switch-success'){
           localStorage.setItem('switchCompanySuccess',false)
       }
       if(attribute=='switch-error'){
           if(params.has('error')){
               localStorage.setItem('switchCompanyError',false)
           }else localStorage.setItem('switchCompanySuccess',false)
       }
        $(current_em).parents(".cart-info").fadeOut(300);
    });

})();
$(document).ready(function(){
    if(pathURL.includes('/a/content') || pathURL.includes('/pages/content')){
          $('[rel="alternate"]').each(function(){
            if($(this).attr('href').includes('monotypefonts')){
                const hrefLangAttr = $(this).attr('hreflang');
                const hrefAttr = $(this).attr('href');
                urltoUpdate = hrefAttr.split('?')[0];
                const url = new URL(urltoUpdate);
                const pagePath = url.pathname;
                if(hrefLangAttr === 'de') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/de') ? `${drupalApiImageBasicUrl}/de/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_de + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_de + pagePath.replace('/a/content','/a/content');
                    }
                    $('#DE').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'fr') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/fr') ? `${drupalApiImageBasicUrl}/fr/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_fr + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_fr + pagePath;
                    }
                    $('#FR').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'es') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/es') ? `${drupalApiImageBasicUrl}/es/` : `${drupalApiImageBasicUrl}/`;
                        const replaceTerm = monotypefonts_url_es + '/a/content/';
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                    }else {
                        urltoUpdate = monotypefonts_url_es + pagePath;
                    }
                    $('#ES').attr("href", urltoUpdate);
                }
                else if(hrefLangAttr === 'en') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        urltoUpdateUK = urltoUpdate.replace(drupalApiImageBasicUrl,monotypefonts_url_english_uk + '/a/content');
                        urltoUpdateUS = urltoUpdate.replace(drupalApiImageBasicUrl,monotypefonts_url_english_us + '/a/content');
                    
                    }else{
                        urltoUpdate = monotypefonts_url_english_us + pagePath;
                        urltoUpdateUS = urltoUpdate;
                        urltoUpdateUK = urltoUpdate.replace(monotypefonts_url_english_us,monotypefonts_url_english_uk);
                    }
                    $('#EN-UK').attr("href", urltoUpdateUK);
                    $('#EN-US').attr("href", urltoUpdateUS);
               }else if(hrefLangAttr === 'pt' || hrefLangAttr.toString() === 'pt-br') {
                    if(hrefAttr.includes('cms.monotypefonts')){
                        const searchTerm = hrefAttr.includes('/pt') ? `${drupalApiImageBasicUrl}/pt/` : `${drupalApiImageBasicUrl}/`;
                        let replaceTerm = ''
                        const pageName = pagePath.split('/').pop();
                        if(pageName == "resources" || pageName === "ressourcen"){
                            replaceTerm = monotypefonts_url_english_us + '/pt/a/content/';
                        }else{
                            replaceTerm = monotypefonts_url_english_us + '/pt/pages/content/';
                        }
                        urltoUpdate = urltoUpdate.replace(searchTerm,replaceTerm);
                        $('#PT').attr("href", urltoUpdate);
                    }
                    
                }
           }
        })
    }
      if(Shopify.country === "GB"){
        const createPitchLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-agency-subscription"]');
        const createDeployLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-individual-and-small-teams-subscription"]');
        const largeBrandsLink = document.querySelector('a[href="https://www.monotypefonts.com/pages/content/plans-enterprise-subscription"]');
        const cartLink = document.querySelector('a[data-analytics-linkname="Subscribe"]');
        if (createPitchLink) {
            createPitchLink.href = createPitchLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (createDeployLink) {
            createDeployLink.href = createDeployLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (largeBrandsLink) {
            largeBrandsLink.href = largeBrandsLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
        if (cartLink) {
            cartLink.href = cartLink.href.replace('monotypefonts.com', 'monotypefonts.co.uk');
        }
    }
})


